"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SokIcon = exports.IconMap = void 0;
var React = require("react");
var checkSquare = '/assets/icons/check_square.svg';
var downloadCloud = '/assets/icons/download.svg';
var dwg = '/assets/icons/dwg.svg';
var exclamationTriangle = '/assets/icons/exclamation_trigger.svg';
var ifc = '/assets/icons/ifc.svg';
var playCircle = '/assets/icons/play_circle.svg';
var timesCircle = '/assets/icons/times_circle.svg';
var timesSquare = '/assets/icons/times_square.svg';
var uploadIFCGreen = '/assets/icons/upload_ifc_green.svg';
var uploadIFCOrange = '/assets/icons/upload_ifc_orange.svg';
var uploadIFCPink = '/assets/icons/upload_ifc_pink.svg';
var uploadIFCRed = '/assets/icons/upload_ifc_red.svg';
var uploadDWGGreen = '/assets/icons/upload_dwg_green.svg';
var uploadDWGPink = '/assets/icons/upload_dwg_pink.svg';
var automaticOrderFolder = '/assets/icons/automatic_order_folder.svg';
var vektorio = '/assets/features/vektorio.svg';
var recompose_1 = require("recompose");
// import './styles.scss'
/*
 * Note, when adding Icons make sure that they have unique classnames for styles!
 * So use find and replace forexample cls-2 -> cls-dwg-2 so that styles dont bleed
 */
var IconMap = function (props) { return ({
    'sok-icon-check-square': checkSquare,
    'sok-icon-download-cloud': downloadCloud,
    'sok-icon-dwg': dwg,
    'sok-icon-exclamation-triangle': exclamationTriangle,
    'sok-icon-ifc': ifc,
    'sok-icon-play-circle': playCircle,
    'sok-icon-times-circle': timesCircle,
    'sok-icon-times-square': timesSquare,
    'sok-icon-3d-green': uploadIFCGreen,
    'sok-icon-3d-orange': uploadIFCOrange,
    'sok-icon-3d-pink': uploadIFCPink,
    'sok-icon-3d-red': uploadIFCRed,
    'sok-icon-2d-green': uploadDWGGreen,
    'sok-icon-2d-pink': uploadDWGPink,
    'sok-icon-automatic-order-folder': automaticOrderFolder,
    'sok-icon-vektorio': vektorio
}); };
exports.IconMap = IconMap;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('SokIcon'), recompose_1.pure);
var regExp = /sok-icon-([\w\-]+)/i;
exports.SokIcon = enhance(function (props) {
    var result = regExp.exec(props.className);
    if (result && result.length > 0) {
        var icons_1 = (0, exports.IconMap)(props);
        var iconName = result.find(function (className) { return icons_1[className] !== ''; });
        var icon = iconName && icons_1[iconName];
        if (icon) {
            return React.createElement("img", __assign({}, props, { src: icon, className: props.className }));
        }
    }
    return React.createElement("span", null, "Unknown icon class");
});
